export default __webpack_public_path__ + "static/media/benifits-section.5d35efd5.png";